var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3bdcf4206aa8d9d164850bbb6783e6e9f4fdf91c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["goatim-web@cyrtous"]={id:"3bdcf4206aa8d9d164850bbb6783e6e9f4fdf91c"};
      